import React from "react";
import { Label2 } from "@irati/ui/src/Labels";
var DefaultHeader = function (_a) {
    var _b = _a.renderProps, _c = _b.HeaderLabel, HeaderLabel = _c === void 0 ? Label2 : _c, showText = _b.showText, hideText = _b.hideText, isExpanded = _b.isExpanded;
    return React.createElement(HeaderLabel, null, isExpanded ? hideText : showText);
};
export default DefaultHeader;
